import { UpdateAccountBalance, UpdateCampaigns, UpdateBonusBalance } from './userAccountDriver'
import { post } from '@classic/Foundation/Services/ApiService'
import { sendToNative } from '@mobi/web-native-comms/web'
import { getCampaigns as getCampaignsV2 } from '@core/Areas/Bonuses'
import { getFeatureValue } from '../FeatureFlags/helpers/getFeatureValue'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { CampaignV2 } from '@core/Areas/Bonuses/data/types'
import type { Campaign } from '@mobi/account/Areas/SignUp'

export async function fetchAccountBalanceAsync(): Promise<void> {
  const { balance } = await getAccountBalance()

  UpdateAccountBalance({ balance })
  sendToNative('ACCOUNT_BALANCE', { balance })
}

export async function fetchCampaignsAsync(): Promise<void> {
  const response = await getCampaignsResponse()
  UpdateCampaigns(response.campaigns)
  UpdateBonusBalance({
    bonusBetBalance: response.bonusBetBalance,
    bonusCashBalance: response.bonusCashBalance,
  })
}

export interface GetAccountBalanceResponse {
  balance: number
  withdrawableBalance: number
}

export interface GetCampaignsResponse {
  bonusBetBalance: number
  bonusCashBalance: number
  campaigns: Campaign[]
}

export function getAccountBalance(): Promise<GetAccountBalanceResponse> {
  return post<GetAccountBalanceResponse>({ url: '/api/account/balance' })
}

function getCampaigns(): Promise<GetCampaignsResponse> {
  return post<GetCampaignsResponse>({ url: '/api/account/campaigns' })
}

async function getCampaignsResponse(): Promise<GetCampaignsResponse> {
  const useCampaignsV2 = getFeatureValue(FeatureFlags.GET_CAMPAIGNS_V2.key)

  if (useCampaignsV2) {
    const bonusRewards = await getCampaignsV2()

    const sumAvailableAmount = (rewards: CampaignV2[], type: string): number => {
      if (rewards) {
        return rewards
          .filter(r => r?.rewardType === type)
          .map(r => r?.remainingAmount || 0)
          .reduce((a, b) => a + b, 0)
      }
      return 0
    }

    const bonusBetBalance = sumAvailableAmount(bonusRewards, 'BonusBetReward')
    const bonusCashBalance = sumAvailableAmount(bonusRewards, 'BonusCashReward')

    const campaignsV2: GetCampaignsResponse = {
      campaigns: bonusRewards,
      bonusBetBalance: bonusBetBalance,
      bonusCashBalance: bonusCashBalance,
    }

    return campaignsV2
  }

  return await getCampaigns()
}
